import React from "react";

const RestartProcessButton = ({ onRestart, status }) => {
  if (!onRestart) return null;
 
  return (
    <button
      className="btn btn-sm btn-warning rounded-pill ms-2"
      title="Restart Process"
      onClick={onRestart}
    >
      <i className="bi bi-arrow-clockwise me-2"></i>
      Restart
    </button>
  );
};

export default RestartProcessButton; 